import ThickCheckingTable from './ThickCheckingTable';

export default ThickCheckingTable;
